module.exports = __webpack_public_path__ + "static/media/gaming.f29127dc.svg";